import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ErrorDialog } from './error-dialog';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
  ],
  declarations: [ErrorDialog],
})
export class ErrorDialogModule {}
